export const IS_MAC = typeof window !== 'undefined'
    && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
